<div class="question-view" [style.max-height.px]="maxHeight">
    <div class="row question-header">
        <div class="question-playword">
            <button type="button" class="btn btn-playword" (click)="playQuestionAudio()"
                [disabled]="!isAudioAllowed() || !hasQuestionAudio || hintIsActive()">
            </button>
        </div>
        <div class="question-view-close">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="userCloseQuestion()">
            </button>
        </div>
    </div>
    <div class="row question-content">
        <label class="question-text" [ngClass]="getQuestionTextUIState()">
            <div class="shiv hidden-lg-down"></div>
            {{
            questionEntry?.question?.text }}
        </label>
        <div class="question-divider-line"></div>
        <div class="quiz-section" *ngIf="questionEntry?.answers?.length > 0">
            <ul class="answers fixed" id="all_answers">
                <li *ngFor="let answer of questionEntry?.answers; let idx = index"
                    id="audio_{{ idx + 1 }}"
                    (click)="selectAnswer(answer)"
                    class="answer"
                    [ngClass]="{
                            'checksItems': questionEntry.type === 'MultipleChecks',
                            'choiceItems': questionEntry.type === 'MultipleChoice',
                            'trueFalse': questionEntry.type === 'TrueFalse',
                            'openBook': questionEntry.type === 'OpenBook',
                            'selected': answer['selected'],
                            'hilited': answer['hilited'],
                            'correctAnswer': answer['tried'] && answer.correct,
                            'wrongAnswer': answer['tried'] && !answer.correct}">
                    {{answer.text}}
                </li>
            </ul>
            <div id="answers_box" class="answers selected" *ngIf="selectedSentences">
                <span>{{selectedGrammaticalSentence}}</span>

            </div>
        </div>
        <div class="question-submit-row">
            <div *ngIf="hasHintText || showClickSentenceHintIcon()" class="question-hint-section">
                <div class="question-hint-section-body">
                    <div class="question-hint-tooltip row" *ngIf="showClickSentenceHintIcon()">
                        <div class="question-click-sentence">Click a sentence in the selection. You may need to scroll.</div>
                    </div>

                    <div class="question-hint-tooltip row" *ngIf="hintTooltip && currentHint">
                        {{ currentHint.text }}
                    </div>

                </div>
            </div>

            <div class="btn-group btn-group-sm submit-btn-block">
                <button type="button" class="submit btn btn-sm " id="question-submit" (click)="submitAnswer()" [disabled]="!allowSubmit">
                    <span [ngSwitch]="validAnswers">
                      <span class="valid-answer-text" *ngSwitchCase="true">Submit</span>
                      <span class="valid-answer-text" *ngSwitchDefault>OK</span>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>